import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-8 items-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "font-medium" }

import { Invoice } from '@/tenants';
import { SvgIcon } from '@/ui-kit';
import { computed } from '@vue/runtime-core';
import { format } from 'date-fns';
import {
	StripeInvoice,
	SubscriptionStatus
} from '../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Invoice',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
	invoice: StripeInvoice;
};



const total = computed(() => {
	return parseInt(props.invoice.total).toFixed(2);
});

const invoiceStatusBg = computed(() => {
	switch (props.invoice.status) {
		case 'paid': {
			return 'bg-green-400';
		}
		case 'open': {
			return 'bg-blue-500';
		}
		default: {
			return 'bg-red-400';
		}
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: __props.invoice.hostedInvoiceUrl,
      target: "_blank",
      class: "flex items-center font-medium cursor-pointer"
    }, [
      _createTextVNode(_toDisplayString(_unref(format)(
					new Date(__props.invoice.created_at),
					'MMM dd, yyyy'
				)) + " ", 1),
      _createVNode(_unref(SvgIcon), {
        class: "ml-2 h-5 w-5 mb-1",
        name: "external-link"
      })
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, "$" + _toDisplayString(_unref(total)), 1),
    _createElementVNode("div", {
      class: _normalizeClass([
				'text-xs font-bold px-1 py-0.5 text-white rounded-md capitalize',
				_unref(invoiceStatusBg)
			])
    }, _toDisplayString(__props.invoice.status), 3)
  ]))
}
}

})